import enCommon from '@/locales/en/common.json';
import enEnums from '@/locales/en/enums.json';
import enNav from '@/locales/en/nav.json';
import type { Bundle, EagerNamespace } from '@/lib/i18n/resources';

// The only English JSON in the main chunk, so `i18n.init` stays synchronous. See loadNamespaces in i18n.ts.
export const EN_EAGER_BUNDLE: Record<EagerNamespace, Bundle> = {
  common: enCommon,
  nav: enNav,
  enums: enEnums,
};
